import React from 'react';
import { Route, RouteProps, RouteComponentProps, useHistory } from 'react-router-dom';
import { useAuth } from '../../contexts/auth.context';

import { SIGNIN_ROUTE } from '../../constants';

type PrivateRouteProps = RouteProps & {
  component: React.ComponentType<RouteComponentProps<any>> | React.ComponentType<any>;
  allowedRoles?: string[];
};

export default function PrivateRoute({
  component: Component,
  allowedRoles = [],
  ...rest
}: PrivateRouteProps): JSX.Element {
  const { isLoading, isAuthenticated, user } = useAuth();
  const { push } = useHistory();

  if (isLoading) {
    return <div style={{ backgroundColor: '#fff' }} />;
  }

  if (!isAuthenticated) {
    push(SIGNIN_ROUTE);
    return <div style={{ backgroundColor: '#fff' }} />;
  }
  
  const hasAccess = allowedRoles.length === 0 || allowedRoles.includes(user.type);

  if (!hasAccess) {
    push(SIGNIN_ROUTE);
    return <div style={{ backgroundColor: '#fff' }} />;
  }

  return <Route {...rest} component={Component} />;
}
